import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";

const TypewriterIntro = () => {
  const heroBackground = {
    background:
      "radial-gradient(circle at top, color-mix(in srgb, var(--accent) 18%, transparent), transparent 24%), radial-gradient(circle at 85% 20%, color-mix(in srgb, var(--primary) 22%, transparent), transparent 26%), linear-gradient(160deg, color-mix(in srgb, var(--bg) 58%, black), color-mix(in srgb, var(--bg) 40%, black) 45%, color-mix(in srgb, var(--bg) 20%, black) 100%)",
  };
  const frameStyle = {
    borderColor: "var(--surface-border)",
    background:
      "linear-gradient(160deg, color-mix(in srgb, var(--surface-strong) 12%, transparent), color-mix(in srgb, var(--surface) 8%, transparent))",
    boxShadow: "0 30px 120px rgba(0,0,0,0.32)",
  };

  return (
    <motion.div
      key="typewriter"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
      className="relative flex min-h-[100svh] flex-col items-center justify-center overflow-hidden px-5 pt-[max(1rem,env(safe-area-inset-top))] pb-[max(2rem,env(safe-area-inset-bottom))] text-center sm:px-6 sm:pt-[max(1.5rem,env(safe-area-inset-top))] sm:pb-[max(4rem,env(safe-area-inset-bottom))]"
    >
      <div className="absolute inset-0" style={heroBackground} />
      <div
        className="absolute inset-x-3 inset-y-3 rounded-[1.6rem] border sm:inset-x-6 sm:inset-y-8 sm:rounded-[2rem]"
        style={frameStyle}
      />

      <p className="relative z-10 mb-5 text-xs font-semibold uppercase tracking-[0.35em] text-[color:var(--accent)]">
        Welcome
      </p>
      <h1 className="relative z-10 mb-5 max-w-4xl text-[2rem] font-semibold leading-[1.08] text-[color:var(--text-strong)] sm:mb-6 sm:text-5xl md:text-6xl">
        <Typewriter
          words={[
            "It's good to see you here.",
            "Very nice to meet you!",
            "Let me take you on a journey about me...",
          ]}
          loop={false}
          typeSpeed={40}
          deleteSpeed={20}
        />
      </h1>
      <p className="relative z-10 max-w-xl text-sm leading-6 text-[color:var(--text-soft)] sm:max-w-2xl sm:text-lg sm:leading-8">
        A concise tour through experience, systems thinking, and the work I care
        about building.
      </p>
    </motion.div>
  );
};

export default TypewriterIntro;
